import { render, staticRenderFns } from "./Tab.MyPreRegistrations.vue?vue&type=template&id=1e81a8aa"
import script from "./Tab.MyPreRegistrations.vue?vue&type=script&lang=js"
export * from "./Tab.MyPreRegistrations.vue?vue&type=script&lang=js"
import style0 from "./Tab.MyPreRegistrations.vue?vue&type=style&index=0&id=1e81a8aa&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports